import React, { useState } from 'react'
import {
  Panel,
  Row,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Input,
  InputGroup,
  Icon,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import { getValueFromOptions } from '../../utils/dataUtil'

export default function InputEvaluatesForm({
  mode = null,
  collapsibleVal = true,
  schema,
  loading,
  register,
  Controller,
  control,
  errors,
  getValues,
  setValue,
  clearErrors,
  disabled,
  onSearch = () => {},
  ...props
}) {
  // const { disabled } = props
  // console.log('disabled=====>555', disabled)
  const INPUT_TYPE = {
    RADIO: 'RADIO',
    INPUTNUMBER: 'INPUTNUMBER',
    CHECKBOX: 'CHECKBOX',
  }

  const iconSize = ''
  const iconColor = '#2da888'

  const panelInputRadio = (item, index) => {
    // console.log(item)
    return (
      <>
        <Panel
          header={<div style={{ color: 'black' }}>{`${index + 1}.  ${item.label}`}</div>}
          collapsible={collapsibleVal}
          defaultExpanded
        >
          {mode == 'VIEW' ? (
            <>
              <Row key={index} style={{ marginTop: -20, marginBottom: -20 }}>
                <p style={{ textIndent: '1.5em' }}>
                  <Icon
                    appearance="ghost"
                    icon="circle"
                    size={iconSize}
                    style={{ marginRight: 5, color: iconColor }}
                  />
                  {item.value ? getValueFromOptions(item.options, item.value) : ''}
                </p>
              </Row>
            </>
          ) : (
            <>
              <Row key={index} style={{ marginTop: -20, marginBottom: -20 }}>
                <ErrorMessage error={errors[item.id]} />
                <Controller
                  key={item.id}
                  name={item.id}
                  control={control}
                  rules={isValidators(item.validators)}
                  defaultValue={item.value}
                  render={(props) => {
                    return (
                      <RadioGroup
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      >
                        {item.options.map((item, index) => {
                          return (
                            <Radio
                              key={index}
                              disabled={disabled}
                              name={item.id}
                              value={item.value}
                            >
                              {item.label}
                            </Radio>
                          )
                        })}
                      </RadioGroup>
                    )
                  }}
                ></Controller>
              </Row>
            </>
          )}
        </Panel>
      </>
    )
  }

  const panelInputCheckbox = (item, index) => {
    // console.log('value arr ', item)
    // { options, value} = item
    return (
      <>
        <Panel
          header={<div style={{ color: 'black' }}>{`${index + 1}.  ${item.label}`}</div>}
          collapsible={collapsibleVal}
          defaultExpanded
        >
          {mode == 'VIEW' ? (
            <>
              <Row key={index} style={{ marginTop: -20, marginBottom: -20 }}>
                {item?.value.length > 0 &&
                  item?.value.map((i) => {
                    return (
                      <p style={{ textIndent: '1.5em' }}>
                        <Icon
                          appearance="ghost"
                          icon="check-square"
                          size={iconSize}
                          style={{ marginRight: 5, color: iconColor }}
                        />
                        {item.value ? getValueFromOptions(item.options, i) : ''}
                      </p>
                    )
                  })}
              </Row>
            </>
          ) : (
            <>
              {console.log('item==>', item)}
              <Row key={index} style={{ marginTop: -20, marginBottom: -20 }}>
                <ErrorMessage error={errors[item.id]} />
                <Controller
                  key={item.id}
                  name={item.id}
                  control={control}
                  rules={isValidators(item.validators)}
                  defaultValue={item.value}
                  render={(props) => {
                    return (
                      <CheckboxGroup
                        value={props.value || []}
                        onChange={(value, checked, e) => {
                          props.onChange(value)
                          if (value.length === 0) setValue(item.id)
                        }}
                      >
                        {item.options.map((item, index) => {
                          return (
                            <Checkbox value={item.value} key={index} disabled={disabled}>
                              {item.label}
                            </Checkbox>
                          )
                        })}
                      </CheckboxGroup>
                    )
                  }}
                ></Controller>
              </Row>
            </>
          )}
        </Panel>
      </>
    )
  }

  const panelInputInputNumber = (item, index) => {
    return (
      <>
        <Panel
          header={<div style={{ color: 'black' }}>{`${index + 1}.  ${item.label}`}</div>}
          collapsible={collapsibleVal}
          defaultExpanded
        >
          {mode == 'VIEW' ? (
            <>
              <Row key={index} style={{ marginTop: -20, marginBottom: -20 }}>
                <p style={{ textIndent: '1.5em' }}>
                  <Icon
                    appearance="ghost"
                    icon="bar-chart"
                    size={iconSize}
                    style={{ marginRight: 5, color: iconColor }}
                  />
                  {`${item.value}%` || ''}
                </p>
              </Row>
            </>
          ) : (
            <>
              <Row key={index} style={{ marginTop: -20, marginBottom: -20 }}>
                <ErrorMessage error={errors[item.id]} />
                <Controller
                  key={item.id}
                  name={item.id}
                  control={control}
                  rules={isValidators(item.validators)}
                  defaultValue={item.value}
                  render={(props) => {
                    return (
                      <InputGroup style={{ width: 300 }}>
                        <Input
                          placeholder={'กรุณากรอกข้อมูล'}
                          value={props.value}
                          onChange={(value, e) => {
                            if (isNaN(value)) {
                              return
                            }
                            props.onChange(value)
                          }}
                          disabled={disabled}
                        />
                        <InputGroup.Addon> %</InputGroup.Addon>
                      </InputGroup>
                    )
                  }}
                ></Controller>
              </Row>
            </>
          )}
        </Panel>
      </>
    )
  }

  return (
    <>
      <Panel bordered>
        {schema.length > 0 && (
          <Panel header={schema.title} collapsible defaultExpanded>
            {schema.map((item, index) => {
              // console.log('item => ', item)

              switch (item.inputType) {
                case INPUT_TYPE.RADIO:
                  return panelInputRadio(item, index)

                case INPUT_TYPE.CHECKBOX:
                  return panelInputCheckbox(item, index)

                case INPUT_TYPE.INPUTNUMBER:
                  return panelInputInputNumber(item, index)

                default:
                  break
              }
            })}
          </Panel>
        )}
      </Panel>
    </>
  )
}
